import { Phone, Bell, Zap, RotateCw, Footprints, Clock } from "lucide-react";
import { T } from "../theme";
import { Eyebrow, Card } from "../components";

function formatTime(iso: string | null): string {
  if (!iso) return "--:--";
  const d = new Date(iso);
  return d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
}

/** ESCALATION — live state from the Fly worker via Cloudflare API */
export function Escalation({ escalation }: { escalation: any }) {
  const isActive = escalation?.is_active === 1;
  const step = escalation?.step ?? 0;
  const lastCall = escalation?.last_call_at;

  const rungs = [
    { label: "Call 1 · warm open", step: 1, icon: Phone },
    { label: "Call 2", step: 2, icon: Phone },
    { label: "Call 3 + SMS", step: 3, icon: Bell },
    { label: "Call 4 · firmer voice", step: 4, icon: Phone },
  ];

  return (
    <div style={{ padding: "18px 16px 24px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Eyebrow>escalation {isActive ? "· active" : ""}</Eyebrow>
        {lastCall && (
          <div className="mono" style={{ fontSize: 10, color: T.dim, display: "flex", alignItems: "center", gap: 4 }}>
            <Clock size={10} /> Last: {formatTime(lastCall)}
          </div>
        )}
      </div>

      <div style={{ marginTop: 18, position: "relative" }}>
        <div style={{ position: "absolute", left: 51, top: 8, bottom: 8, width: 2, background: `linear-gradient(${T.mist}, ${T.dawn})` }} />
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {rungs.map((r) => {
            const active = step === r.step && isActive;
            const done = step > r.step;
            return (
              <div key={r.label} style={{ display: "flex", alignItems: "center", gap: 12, opacity: done ? 0.6 : 1 }}>
                <span className="mono" style={{ width: 42, textAlign: "right", fontSize: 11, color: done ? T.dim : active ? T.dawn : T.mist, fontWeight: active ? 700 : 500 }}>
                  {active ? "NOW" : done ? "✓" : r.step}
                </span>
                <div style={{ width: 18, display: "flex", justifyContent: "center", position: "relative", zIndex: 1 }}>
                  <div style={{
                    width: active ? 12 : 10,
                    height: active ? 12 : 10,
                    borderRadius: active ? 6 : 5,
                    background: done ? T.mint : active ? T.dawn : T.panel,
                    border: `2px solid ${done ? T.mint : active ? T.dawn : T.gold}`,
                    animation: active ? "zbPulse 1.2s infinite" : "none",
                  }} />
                </div>
                <Card style={{ flex: 1, padding: "9px 12px", display: "flex", alignItems: "center", gap: 8 }}>
                  <r.icon size={13} color={done ? T.mint : active ? T.dawn : T.gold} />
                  <span style={{ fontSize: 12.5, color: done ? T.dim : active ? T.dawn : T.paper, fontWeight: active ? 700 : 500 }}>{r.label}</span>
                </Card>
              </div>
            );
          })}

          {/* Hard Wake */}
          <div style={{ display: "flex", alignItems: "center", gap: 12, opacity: step >= 5 ? 1 : 0.4 }}>
            <span className="mono" style={{ width: 42, textAlign: "right", fontSize: 11, color: step >= 5 ? T.dawn : T.dim, fontWeight: step >= 5 ? 700 : 500 }}>
              {step >= 5 ? "NOW" : "5"}
            </span>
            <div style={{ width: 18, display: "flex", justifyContent: "center", position: "relative", zIndex: 1 }}>
              <div style={{
                width: step >= 5 ? 12 : 10,
                height: step >= 5 ? 12 : 10,
                borderRadius: step >= 5 ? 6 : 5,
                background: step >= 5 ? T.dawn : T.panel,
                border: `2px solid ${step >= 5 ? T.dawn : T.dawn}`,
                animation: step >= 5 ? "zbPulse 1.2s infinite" : "none",
              }} />
            </div>
            <div style={{ flex: 1, borderRadius: 14, padding: "11px 12px", background: step >= 5 ? "rgba(255,107,69,.1)" : "rgba(255,107,69,.04)", border: `1px solid ${step >= 5 ? "rgba(255,107,69,.45)" : "rgba(255,107,69,.2)"}` }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Zap size={14} color={T.dawn} />
                <span style={{ fontSize: 13, color: step >= 5 ? T.dawn : T.dim, fontWeight: 700 }}>HARD WAKE</span>
              </div>
              <div style={{ fontSize: 11.5, color: step >= 5 ? T.mist : T.dim, marginTop: 4, lineHeight: 1.45 }}>
                Calls every 2 min. Never auto-stops. Native phone alarm fires if nothing is dismissed.
              </div>
            </div>
          </div>
        </div>
      </div>

      <Card style={{ marginTop: 16 }}>
        <Eyebrow color={T.gold}>re-verify</Eyebrow>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 7 }}>
          <RotateCw size={13} color={T.gold} />
          <span style={{ fontSize: 12.5, color: T.paper }}>
            Callback <span className="mono" style={{ color: T.gold, fontWeight: 600 }}>+10 min</span> after dismissal — "still vertical?"
          </span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 7 }}>
          <Footprints size={13} color={T.mist} />
          <span style={{ fontSize: 12, color: T.mist }}>Saturday mode: scan the bathroom QR instead</span>
        </div>
      </Card>
    </div>
  );
}
